import { Signal } from '@angular/core';
import { DataGuardCheck, DataGuardEvent } from '@iot-platform/models/data-guard';

export abstract class AbstractDataGuardService {
  abstract overviewChecks: Signal<DataGuardCheck[]>;
  abstract detailedChecks: Signal<DataGuardCheck>;

  abstract dispatchDataGuardEvent(event: DataGuardEvent): void;
}
